import { appendLocaleSources } from '../../hooks/useTranslate'
import ReportPresenter from '../../api/reportPresenter'

appendLocaleSources({
  [ReportPresenter.urn]: {
    page: {
      title: 'Отчеты',
    },
    modal: {
      title: {
        create: 'Создать настройку',
        update: 'Обновить настройку',
      },
    },
    action: {
      create: 'Скачать Отчет',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить эту настройку?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [ReportPresenter.urn]: {
    page: {
      title: 'Reports',
    },
    modal: {
      title: {
        create: 'Create Setting',
        update: 'Update Setting',
      },
    },
    action: {
      create: 'Download Report',
    },
    message: {
      confirmDelete: `Are you sure you want to delete this setting?`,
    },
  },
}, 'en')

appendLocaleSources({
  [ReportPresenter.urn]: {
    page: {
      title: 'Hisobotlar',
    },
    modal: {
      title: {
        create: 'Sozlama yaratish',
        update: 'Sozlamani yangilash',
      },
    },
    action: {
      create: 'Hisobotni yuklab olish',
    },
    message: {
      confirmDelete: `Ushbu sozlamani o'chirishni xohlaysizmi?`,
    },
  },
}, 'uz')


